import React from 'react';

import { CalendarDays } from 'components/Calendar/child-components/CalendarDays';

export const CalendarHeader = ({ currentMonth }) => (
    <thead>
        <tr>
            <th colSpan={7} className="datepicker-year-heading">
                {currentMonth.format('YYYY')}
            </th>
        </tr>
        <tr>
            <th colSpan={7} className="datepicker-month-heading">
                {currentMonth.format('MMMM')}
            </th>
        </tr>
        <CalendarDays />
    </thead>
);
